import React from "react";
import "./CardForm.scss";

interface CardFormProps {
	title: string;
	icon: string;
	children: React.ReactNode;
	className?: string;
	description?: string;
}

export default function CardForm({
	title,
	children,
	icon,
	className = "",
	description = "",
}: Readonly<CardFormProps>) {
	return (
		<div className={`${className} form-card`}>
			<div className="row d-flex align-items-center">
				<div className="col-auto pe-0 mx-1">
					<i className={`${icon} icon-title-dataset`} />
				</div>
				<div className="col ps-0 title-form-card">{title}</div>
				{description && (
					<div className="section-description">{description}</div>
				)}
			</div>

			<div className="row">
				<div className="col">{children}</div>
			</div>
		</div>
	);
}
